module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1200.fb6f8996.svg";